var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 138,
    viewBox: "0 0 1440 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 138
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 138,
    fill: "#03B8EC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.000976562,
    y: 162,
    width: 162,
    height: 1440,
    transform: "rotate(-90 -0.000976562 162)",
    fill: "#060F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127 -57.0005C1127 92.6687 1005.45 214 855.5 214C705.555 214 584 92.6687 584 -57.0005",
    stroke: "url(#paint0_linear)",
    strokeWidth: 304
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 425C25 275.33 146.555 153.999 296.5 153.999C446.445 154 568 275.33 568 425",
    stroke: "url(#paint1_radial)",
    strokeWidth: 244
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.000976562,
    y: 162,
    width: 162,
    height: 1440,
    transform: "rotate(-90 -0.000976562 162)",
    fill: "#060F6B",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1012,
    y1: 189,
    x2: 1138,
    y2: -57.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C137B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C137B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(591.439 289.5) rotate(180) scale(762.544 380.57)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119BD9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCalendar);
export default __webpack_public_path__ + "static/media/headerCalendar.9c522c7edf31125178b8b8ef87e9ad2a.svg";
export { ForwardRef as ReactComponent };